import React from "react";
import {GameCard} from "./GameCard";
import {GameDto} from "../../games/types";
import {Flex} from "antd";
import {SelectableGame} from "../auth/types";

export const GameCollectionDisplay: React.FC<{games: SelectableGame[]}> = ({games}) => {
    return (
        <Flex wrap={"wrap"} align={"start"} justify={"start"} >
            {games.map((game) =>
                <GameCard game={game as any as GameDto} />
            )}
        </Flex>
    )
}